import { render, staticRenderFns } from "./prueba3.vue?vue&type=template&id=752980c0"
import script from "./prueba3.vue?vue&type=script&lang=js"
export * from "./prueba3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports